export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12121.81345ced.jpg";